var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.link}},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.alt}}),_vm._v(" "),(!_vm.loaded)?_c('font-awesome-icon',{attrs:{"icon":"spinner","spin":"","size":"lg"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }